export const parseQueryStringObj = urlParam => {
  let url = urlParam;
  if (typeof url !== 'string') {
    return {};
  }
  url = url.trim();
  if (!url || url.indexOf('?') === -1) {
    return {};
  }
  [, url] = url.split('?');
  const obj = {};
  try {
    const pairs = url.split('&');
    for (let i = 0; i < pairs.length; i += 1) {
      const parts = pairs[i].split('=');
      if (parts[0] && parts[1]) {
        obj[parts[0]] = decodeURIComponent(parts[1]) || '';
      }
    }
  } catch (e) {
    console.log(e);
  }
  return obj;
};

export const getQueryString = (name, url) => {
  const parserUrl = url || window.location.search;
  const param = new URLSearchParams(parserUrl);
  return param.get(name);
};

const parseUrl = { parseQueryStringObj, getQueryString };

export default parseUrl;
